export default "__VITE_ASSET__PDWz77bn__"